import React from "react";
import Str from "shared/components/Str";
import classnames from "classnames";

import _str from "shared/util/_str";
import Actions from "okpay/actions/Actions";
import TextInput from "okpay/util/TextInput";
import C from "okpay/util/Constants";

const CardType = ({ cardType }) => {
	if (cardType === C.cardTypes.none || cardType === C.cardTypes.all) {
		return null;
	}

	const classMap = {
		"okpay-cardtype": true,
	};
	classMap[`okpay-cardtype--${cardType}`] = true;
	return <span className={classnames(classMap)} />;
};

class CardNumber extends React.Component {
	_fixValue = (_value) => {
		// strip out all non-numbers, and then truncate
		let value = _value;
		value = value.replace(/\D/gi, "");
		value = value.substr(0, C.cardNumberMaxLength);
		return value;
	};

	_onChange = (e) => {
		const value = this._fixValue(e.target.value);

		// update the stored value
		Actions.updateField({ cardNumber: value });
	};

	render() {
		const classes = classnames({
			"okpay-item": true,
			"okpay-item-cardnumber": true,
		});

		// max length is the max card length, plus the spacing
		const maxLength =
			C.cardNumberMaxLength + Math.floor(C.cardNumberMaxLength / 4) - 1;

		return (
			<div className={classes}>
				<div className="okpay-item-element">
					<TextInput
						value={this.props.value.replace(/(\d{4})\B/g, "$1 ")}
						name="cardNumber"
						label={_str("Card Number")}
						maxLength={maxLength}
						autoComplete="on"
						onChange={this._onChange}
					/>
					<CardType cardType={this.props.cardType} />
				</div>
				<p className="okpay-item-note">
					<Str>We accept all major debit/credit cards.</Str>
				</p>
			</div>
		);
	}
}

export default CardNumber;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/fields/CardNumber.jsx